import { captureException } from '@sentry/react';

declare global {
  interface Window {
    tatari: {
      track: (eventKey: string, data?: { [key: string]: unknown }) => void;
      identify: (userId: string) => void;
    };
  }
}

const PURCHASE_EVENT_KEY = 'Purchase';

const checkTatariInitialized = () => {
  if (typeof window.tatari === 'undefined') {
    throw new Error('Tatari API not initialized');
  }
  return true;
};

export const TatariApi = {
  trackEvent: (eventKey: string, data?: { [key: string]: unknown }) => {
    try {
      if (checkTatariInitialized()) {
        window.tatari.track(eventKey, data);
        console.log('Tatari event tracked:', eventKey, data);
      }
    } catch (error) {
      console.error('error', error);
      captureException(error);
    }
  },
  trackPurchase: (orderId: string, total: number) => {
    try {
      if (checkTatariInitialized()) {
        window.tatari.track(PURCHASE_EVENT_KEY, { orderId, total });
        console.log('Tatari purchase tracked:', orderId, total);
      }
    } catch (error) {
      console.error('error', error);
      captureException(error);
    }
  },
  identify: (userId: string) => {
    try {
      if (checkTatariInitialized()) {
        window.tatari.identify(userId);
        console.log('Tatari user identified:', userId);
      }
    } catch (error) {
      console.error('error', error);
      captureException(error);
    }
  }
};
